import React from 'react';
import { Select, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { selectorShape } from './Refiner.props';
import { makeStyles, serializeDate } from 'utils';
import classes from './Refiner.module.css';
import moment from 'moment';


import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

function RefinerDateField({
    idBase,
    readOnly,
    selector,
    value,
    onChange
}) {
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                id={idBase + '_value'}
                label="Value"
                variant="inline"
                required
                disabled={readOnly}
                error={!!selector.error}
                helperText={selector.error || null}
                InputProps={{ className: classes['form-input'] }}
                format="dd/MM/yyyy"
                value={value || null}
                onChange={handleValueChange}
            />
        </MuiPickersUtilsProvider>
    );

    function handleValueChange(val) {
        if (!val) {
            onChange(null);
            return;
        }

        val.setHours(0, 0, 0, 0);
        value = serializeDate(val);
        onChange(
            {
                target: {
                    value
                }
            }
        );
    }

}

RefinerDateField.propTypes = {
    idBase: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    selector: PropTypes.shape(selectorShape),
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default RefinerDateField;